/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./html-content-item.component";
import * as i2 from "@angular/platform-browser";
var styles_HtmlContentItemComponent = [];
var RenderType_HtmlContentItemComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_HtmlContentItemComponent, data: {} });
export { RenderType_HtmlContentItemComponent as RenderType_HtmlContentItemComponent };
export function View_HtmlContentItemComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["class", "card card-wider card-cascade"]], [[8, "innerHTML", 1]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.content; _ck(_v, 0, 0, currVal_0); }); }
export function View_HtmlContentItemComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-html-content-item", [], null, null, null, View_HtmlContentItemComponent_0, RenderType_HtmlContentItemComponent)), i0.ɵdid(1, 4308992, null, 0, i1.HtmlContentItemComponent, [i2.DomSanitizer], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var HtmlContentItemComponentNgFactory = i0.ɵccf("app-html-content-item", i1.HtmlContentItemComponent, View_HtmlContentItemComponent_Host_0, { results: "data" }, {}, []);
export { HtmlContentItemComponentNgFactory as HtmlContentItemComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/html-content-item/html-content-item.component.ngfactory.js.pre-build-optimizer.js